module.exports = __webpack_public_path__ + "static/media/img_background_basketball.d51d3e9b.jpg";